export function getGenericHandicapDescriptionPart(betId, handicap, position) {
	const map = {
		1 : "x",
		2 : "y",
		3 : "z",
		4 : "k",
		5 : "w",
		6 : "j",
		7 : "t",
		8 : "h"
	}
	return map[position];
}
